import { getBaseUrl } from '@/apis/request';
import { CONFIG_DISABLED_EVENT_TRACKER, getBooleanConfig } from '@/hooks/uesAppConfig';
import sensors from 'sa-sdk-javascript';
import { Cookies } from 'react-cookie';
// import ampHandler from '@omc/apm-upload';
import { EAPP_CHANNEL_VALUE, getAppChannelValue } from '@/channels';

function getPlatformType() {
  switch (getAppChannelValue()) {
    case EAPP_CHANNEL_VALUE.DOUYIN:
      return 'TikTok';
    case EAPP_CHANNEL_VALUE.UNIONPAY:
    default:
      return 'unionpay';
  }
}

function getOnceProfileData(): object {
  const time = new Date().toJSON().replace('T', ' ').replace('Z', '');

  switch (getAppChannelValue()) {
    case EAPP_CHANNEL_VALUE.DOUYIN:
      return {
        first_visit_tiktok_time: time,
      };
    case EAPP_CHANNEL_VALUE.UNIONPAY:
    default:
      return {
        first_visit_unionpay_time: time,
      };
  }
}

export const initTracker = () => {
  if (getBooleanConfig(CONFIG_DISABLED_EVENT_TRACKER, false)) {
    return;
  }

  // tracker server url
  const apiDomain = getBaseUrl() || '';
  let server = '';
  if (apiDomain.indexOf('api.mcd.cn') > -1) {
    server = 'https://tracking.mcdonalds.com.cn/sa?project=CMA';
  } else {
    server = 'https://tracking.mcdonalds.com.cn/sa?project=default';
  }

  let host = '';
  try {
    if (typeof location !== 'undefined') {
      host = location.host;
    }
  } catch (error) {
    // ignore
  }

  sensors.init({
    name: 'sensors',
    web_url: process.env.APP_DEPLOY_ENV === 'prod' ? host : undefined,
    server_url: server,
    // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    },
  });

  sensors.registerPage({
    platform_type: getPlatformType(),
    app_name: 'all in one',
  });

  sensors.quick('autoTrack');
  sensors.setOnceProfile(getOnceProfileData());

  trackUserLogin();

  // test apm event tracker
  // ampHandler.uploadEventInfo(
  //   'INIT_TRACKER',
  //   Date.now(),
  //   JSON.stringify({
  //     ex1: JSON.stringify({
  //       platform_type: 'unionpay',
  //       app_name: 'all in one',
  //     }),
  //   }),
  //   37,
  // );
};

export const trackUserLogin = () => {
  const cookies = new Cookies();
  const userId = cookies.get<string>('meddyId');
  if (userId && userId.length > 0) {
    sensors.login(userId);
  }
};

export const trackEvent = (eventName: string, params: object) => {
  if (getBooleanConfig(CONFIG_DISABLED_EVENT_TRACKER, false)) {
    return;
  }

  try {
    sensors.track(eventName, params);
  } catch (error) {
    console.error('[tracker] track event err: %o', error);
  }
};
